import * as React from "react";
import {
    Create,
    Edit,
    SimpleForm,
    TextInput,
    NumberInput,
    BooleanInput,
    BooleanField,
    ReferenceInput,
    AutocompleteInput,
    required,
    Toolbar,
    SaveButton,
    TextField,
    FunctionField,
    Datagrid,
    List,
    DeleteButton,
    EditButton,
} from 'react-admin';

const EditToolbar = props => (
    <Toolbar {...props}>
        <SaveButton />
    </Toolbar>
);

const rowStyle = record => {
    if (record.stage === null || record.stage === undefined) {
        return { backgroundColor: '#fff9c4' };
    }
    return {};
};

const wildcardField = (
    <FunctionField
        label="Wildcard?"
        sortable={false}
        render={record => {
            if (record.wildcard_approval === null || record.wildcard_approval === undefined) {
                return '-';
            }
            return <BooleanField record={record} source="wildcard_approval" looseValue={true} />;
        }}
    />
);

const transform = data => ({
    user_id: data.approver && data.approver.user_id,
    role_name: data.approver && data.approver.role_name,
    can_undo_final_approval: (data.approver && data.approver.can_undo_final_approval) || false,
    stage: data.stage || 1,
    wildcard_approval: data.wildcard_approval || false,
});

export const ProductionApprovalEntriesList = props => {
    const filters = [
        <BooleanInput alwaysOn source="hide_unassigned" label="Hide unassigned" />,
    ];

    return (
        <List {...props} filters={filters}>
            <Datagrid rowStyle={rowStyle} rowClick="edit">
                <TextField source="stage" label="Stage #" emptyText="-" />
                <TextField source="approver.user.name" label="Approver" sortable={false} />
                <TextField source="approver.role_name" label="Role" sortable={false} emptyText="-" />
                {wildcardField}
                <BooleanField source="approver.can_undo_final_approval" label="Can Undo Final Approval?" looseValue={true} sortable={false} />
                <EditButton />
                <DeleteButton />
            </Datagrid>
        </List>
    );
};

export const ProductionApprovalEntriesCreate = props => (
    <Create {...props} title="New Production Approval Entry">
        <SimpleForm toolbar={<EditToolbar />} redirect="list">
            <ReferenceInput source="user_id" reference="users" label="User" perPage={1000} validate={[required()]}>
                <AutocompleteInput optionText="name" />
            </ReferenceInput>
            <TextInput source="role_name" label="Role Name" />
            <NumberInput source="stage" label="Stage" defaultValue={1} inputProps={{ min: 1 }} validate={[required()]} />
            <BooleanInput source="wildcard_approval" label="Wildcard Approver" />
            <BooleanInput source="can_undo_final_approval" label="Can Undo Final Approval" />
        </SimpleForm>
    </Create>
);

export const ProductionApprovalEntriesEdit = props => (
    <Edit {...props} title="Edit Production Approval Entry" transform={transform}>
        <SimpleForm toolbar={<EditToolbar />} redirect="list">
            <ReferenceInput source="approver.user_id" reference="users" label="User" perPage={1000} validate={[required()]}>
                <AutocompleteInput optionText="name" />
            </ReferenceInput>
            <TextInput source="approver.role_name" label="Role Name" />
            <NumberInput source="stage" label="Stage" defaultValue={1} inputProps={{ min: 1 }} validate={[required()]} />
            <BooleanInput source="wildcard_approval" label="Wildcard Approver" />
            <BooleanInput source="approver.can_undo_final_approval" label="Can Undo Final Approval" />
        </SimpleForm>
    </Edit>
);
